export const getErrorContext = (context = {}) => {
    const { locale, req = {}, resolvedUrl } = context;
    const { headers = {}, url } = req;
    const errorContext = {
        url: resolvedUrl || url,
        locale,
        ip: headers['x-real-ip'],
        userAgent: headers['user-agent']
    };
    return errorContext;
};

export const getErrorMessage = error => {
    switch (typeof error) {
        case 'string':
            return error;
        case 'object':
            if (error?.name && error?.message) {
                return `${error.name}: ${error.message}`;
            } else if (error?.message) {
                return error.message;
            }
            return `unknown error object: ${error}`;
        default:
            return `unknown error type caught: ${error}`;
    }
};
